import * as css from 'css/exports.module.scss';
import './GroupedChangesChart.scss';
import { getTimelineGroupedSummarySelector } from './@arch/selectors';
import { NoData } from '@ui/NoData';
import { TIMELINE_COPY } from '@sonar-software/sonar-ts-constants';
import { TimelineGroupingType } from '@sonar-software/sonar-core';
import { Column } from '@ant-design/plots';
import { Else, If, Then } from 'react-if';
import { Radio } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { useSonarSelector } from '@hooks';
const wholeNumbersOnly = (val) => (Number(val) < Math.ceil(Number(val)) ? null : val);
const chartConfig = {
    color: [css.addition, css.modification, css.deletion],
    data: [],
    height: 400,
    isGroup: true,
    legend: {
        layout: 'horizontal',
        position: 'bottom'
    },
    seriesField: 'name',
    slider: {
        end: 1,
        start: 0
    },
    xField: 'date',
    yAxis: {
        label: {
            formatter: wholeNumbersOnly
        }
    },
    yField: 'value'
};
const formatTimestamp = (timestamp, format) => new Date(timestamp).toLocaleDateString('en-us', Object.assign(Object.assign({}, format), { timeZone: 'UTC' }));
const getDate = (timestamp, grouping) => {
    switch (grouping) {
        case TimelineGroupingType.Year:
            return formatTimestamp(timestamp, { year: 'numeric' });
        case TimelineGroupingType.Month:
            return formatTimestamp(timestamp, { month: 'short' });
        default:
            return formatTimestamp(timestamp, {
                day: 'numeric',
                month: 'short'
            });
    }
};
export const GroupedChangesChart = ({ grouping, onChange }) => {
    const groupedSummary = useSonarSelector(getTimelineGroupedSummarySelector.data);
    const disabled = !(groupedSummary === null || groupedSummary === void 0 ? void 0 : groupedSummary.changes.length);
    const data = useMemo(() => groupedSummary === null || groupedSummary === void 0 ? void 0 : groupedSummary.changes.reduce((chartData, { date: timestamp, discovered, modified, vanished }) => {
        const date = getDate(timestamp, grouping);
        return [
            ...chartData,
            {
                date,
                name: TIMELINE_COPY.ADDITIONS,
                value: discovered
            },
            {
                date,
                name: TIMELINE_COPY.MODIFICATIONS,
                value: modified
            },
            {
                date,
                name: TIMELINE_COPY.DELETIONS,
                value: vanished
            }
        ];
    }, []
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [groupedSummary === null || groupedSummary === void 0 ? void 0 : groupedSummary.changes]);
    const handleOnChange = useCallback((e) => {
        onChange({ timelineGroupingType: e.target.value });
    }, [onChange]);
    return (React.createElement("div", { className: 'grouped-changes-chart' },
        React.createElement(Radio.Group, { disabled: disabled, onChange: handleOnChange, options: Object.values(TimelineGroupingType), optionType: 'button', size: 'small', value: grouping }),
        React.createElement(If, { condition: disabled },
            React.createElement(Then, null,
                React.createElement(NoData, { description: TIMELINE_COPY.NO_CHANGES_MADE_DURING_TIMEFRAME })),
            React.createElement(Else, null,
                React.createElement(Column, Object.assign({ className: 'chart' }, chartConfig, { data: data !== null && data !== void 0 ? data : [] }))))));
};
